import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=b6248f44"
import script from "./ContentLayout.vue?vue&type=script&lang=js"
export * from "./ContentLayout.vue?vue&type=script&lang=js"
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=b6248f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports